<template>
  <div class="flex justify-between items-center mt-1 mb-2">
    <select v-model="PageSize" @change="selectedHandler()">
      <option v-for="(item, index) in filterLimit" :key="index" :value="item">
        {{ item }}
      </option>
    </select>
    <input
      @input="searchHandler()"
      v-model="search"
      placeholder="Search Transaction Number or Member Name"
      type="text"
      class="w-96 border rounded px-4 py-2 text-sm"
    />
  </div>
  <div
    v-if="$route.name === 'Reimbursement'"
    class="py-5 flex justify-between items-center border-b border-gray-200"
  >
    <ul class="text-xs space-x-8 flex">
      <li
        v-for="tab in statusTabs"
        :key="tab"
        @click="handleTabClick(tab)"
        class="cursor-pointer pb-2"
        :class="[
          selectedTab === tab
            ? 'border-b-2 border-primary text-orange-500 font-semibold'
            : 'text-gray-600 hover:text-primary',
        ]"
      >
        {{ tab }} ({{ itemApprovalCount[tab] ?? 0 }})
      </li>
    </ul>
    <div class="flex items-center gap-2 mb-4">
      <label for="sortBy" class="text-sm font-medium text-gray-700">
        Sort by
      </label>
      <select
        @change="selectDescriptionHandler()"
        v-model="sortByDescription"
        id="sortBy"
        class="border border-gray-300 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="" disabled selected>--- Select Type ---</option>
        <option value="membername">Member Name</option>
        <option value="providername">Provider Name</option>
        <option value="graceperiod"># of Days to Comply</option>
        <option value="createdAt">Entry Date</option>
      </select>

      <select
        @change="selectSortHandler()"
        v-model="sortBy"
        id="sortDirection"
        class="border border-gray-300 rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <option value="ASC">Ascending</option>
        <option value="DESC">Descending</option>
      </select>
    </div>
  </div>
  <div v-else class="pb-6 px-2" />
</template>

<script>
import UsedPaginationUtils from "@/utils/reusables/pagination";
import { toRefs, ref, onMounted } from "vue";
export default {
  components: {},

  props: {
    itemApprovalCount: Object,
    selectedTab: {
      type: String,
      default: "All",
    },
  },
  setup(props, { emit }) {
    const { paginationItem, totalPages, filterLimit } = UsedPaginationUtils();
    const search = ref();
    const sortByDescription = ref("createdAt");
    const sortBy = ref("DESC");
    const selectedHandler = () => {
      emit("getPageSize", paginationItem.PageSize);
    };
    const searchHandler = () => {
      emit("getSearch", search.value);
    };

    const statusTabs = [
      "All",
      "Assessment",
      "Pending Documents",
      "Approved",
      "Declined",
    ];
    const activeTab = ref("All");
    onMounted(() => {});

    const handleTabClick = (tab) => {
      activeTab.value = tab;
      emit("selectedFilter", activeTab.value);
      // Optional: emit event or filter data
    };
    const selectDescriptionHandler = () => {
      emit("getSortByDescription", sortByDescription.value);
    };
    const selectSortHandler = () => {
      emit("getSortBy", sortBy.value);
    };
    return {
      totalPages,
      filterLimit,
      search,
      ...toRefs(paginationItem),
      selectedHandler,
      searchHandler,
      statusTabs,
      activeTab,
      handleTabClick,
      sortByDescription,
      sortBy,
      selectDescriptionHandler,
      selectSortHandler,
    };
  },
};
</script>
